<div class="export menu-anchor">
    <button
        type="button"
        class="export-pill"
        [class.open]="isOpen"
        [disabled]="count === 0"
        (click)="ToggleMenu()">
        <svg class="pill-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M8 1.5v8M8 9.5l-3-3M8 9.5l3-3M2.5 11v2.5h11V11"
                  fill="none" stroke="currentColor" stroke-width="1.4"
                  stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Export Selected ({{ count }})</span>
    </button>

    <div class="popover" *ngIf="isOpen">
        <label class="format-pick">
            <span>Format</span>
            <select [(ngModel)]="format" [disabled]="isExporting">
                <option value="xlsx">XLSX</option>
                <option value="csv">CSV</option>
            </select>
        </label>
        <label class="include-summaries">
            <input
                type="checkbox"
                [(ngModel)]="includeSummaries"
                [disabled]="isExporting" />
            <span>Include summaries</span>
        </label>
        <p class="cap-warning" *ngIf="overCap">
            Capped at {{ cap }} candidates — the first {{ cap }} will be included.
        </p>
        <button
            type="button"
            class="confirm-btn"
            [disabled]="disabled"
            (click)="Export()">
            {{ isExporting ? 'Exporting…' : 'Export ' + count }}
        </button>
        <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>
</div>
